import { NavLink } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { Heart, Home, LayoutGrid, Search, ShoppingBag } from "lucide-react";

const ITEMS = [
  { to: "/", label: "Ana Sayfa", icon: Home, testid: "bottom-nav-home" },
  { to: "/kategori/kolyeler", label: "Kategoriler", icon: LayoutGrid, testid: "bottom-nav-categories" },
  { to: "/ara", label: "Ara", icon: Search, testid: "bottom-nav-search" },
  { to: "/favoriler", label: "Favoriler", icon: Heart, testid: "bottom-nav-favorites" },
];

export function MobileNav() {
  const { cartCount, setCartOpen } = useStore();

  return (
    <nav data-testid="mobile-bottom-nav" aria-label="Mobil alt menü"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 h-16 bg-shule-paper/95 backdrop-blur-md border-t border-shule-line shadow-[0_-4px_20px_rgba(44,34,30,0.06)]">
      <div className="grid grid-cols-5 h-full">
        {ITEMS.map(({ to, label, icon: Icon, testid }) => (
          <NavLink key={to} to={to} data-testid={testid} end={to === "/"}
            className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 min-h-[44px] text-[10px] font-semibold transition-colors ${isActive ? "text-shule-goldhover" : "text-shule-soft"}`}>
            <Icon className="w-5 h-5" />
            {label}
          </NavLink>
        ))}
        <button data-testid="bottom-nav-cart" onClick={() => setCartOpen(true)}
          className="relative flex flex-col items-center justify-center gap-0.5 min-h-[44px] text-[10px] font-semibold text-shule-soft">
          <ShoppingBag className="w-5 h-5" />
          Sepet
          {cartCount > 0 && (
            <span data-testid="bottom-nav-cart-badge" className="absolute top-1.5 right-1/2 translate-x-5 min-w-[18px] h-[18px] px-1 rounded-full bg-shule-coffee text-shule-paper text-[10px] font-bold flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </button>
      </div>
    </nav>
  );
}
